export default __webpack_public_path__ + "static/media/au.992aea88.svg";